module.exports = __webpack_public_path__ + "static/media/star_yellow.60ba61d0.svg";